import GiselaNavDropdown from "@/components/gisela/GiselaNavDropdown"
import type { ConditionMenuGroup } from "@/types/inertia"

interface Props {
  label: string
  href: string
  menu: ConditionMenuGroup[]
  browseLabel: string
  /** The venue's nav is transparent over its heroes until scrolled. */
  scrolled: boolean
}

// The venue nav's dropdown — Gisela's hand-rolled, crawlable menu (every
// link stays in the server-rendered HTML) in the venue nav's colours: white
// over the hero, ink once the bar has scrolled to cream.
export default function PublicNavDropdown({ label, href, menu, browseLabel, scrolled }: Props) {
  return (
    <GiselaNavDropdown
      label={label}
      href={href}
      menu={menu}
      browseLabel={browseLabel}
      triggerClassName={scrolled ? "text-ink-body" : "text-white"}
      chevronClassName={
        scrolled
          ? "text-ink-muted hover:bg-surface hover:text-ink-body"
          : "text-white/70 hover:bg-white/10 hover:text-white"
      }
    />
  )
}
